import { TabsLine } from 'Components/lines/tabs-line/TabsLine';
export default TabsLine;
